<template>
  <div class="detail-product">

    <div class="container">
      <product-carousel
        v-if="currentimages"
        :is-new="isNew"
        :images="currentimages"
      >
        <slot name="tooltip"></slot>
      </product-carousel>


      <div class="detail-product__content">
        <slot name="title"></slot>
        <!-- <rating-component :value="rating"></rating-component> -->

        <slot name="description"></slot>

        <div class="detail-product__controls">

            <div class="detail-product__weight" v-if="variations.length">
              <div class="detail-product__weight-title">Вес:</div>
              <div class="detail-product__weight-list">
                <div
                  v-for="variation, key in variations"
                  class="detail-product__weight-item"
                  :class="{current: key === currentVariation}"
                  @click="setCurrentVariation(key)"
                >{{ variation.weight }}</div>
              </div>
            </div>
          <a
            :href="variations[currentVariation].buy_button_url"
            class="detail-product__buy btn btn--accent"
            target="_blank"
            data-product-link
          >Купить</a>
          <!-- <a href="#" class="detail-product__link detail-product__link--small">Отзывы</a> -->
        </div>
      </div>
    </div>
  </div>
  <div class="popup-buy" v-if="loggedIn" ref="popupBuy" :class="{show:popupBuyShow}">
    <div class="popup-buy__close" @click="closePopupBuy"></div>
    <div class="container popup-buy__container">
      <div class="popup-buy__text">
        <div class="popup-buy__title" v-html="title"></div>
        <div class="popup-buy__description" v-html="subtitle"></div>
      </div>
      <div class="popup-buy__controls">
        <div class="detail-product__weight" v-if="variations.length">
          <div class="detail-product__weight-title">Вес:</div>
          <div class="detail-product__weight-list">
            <div
              v-for="variation, key in variations"
              class="detail-product__weight-item"
              :class="{current: key === currentVariation}"
              @click="setCurrentVariation(key)"
            >{{ variation.weight }}</div>
          </div>
        </div>
        <a
          :href="variations[currentVariation].buy_button_url"
          class="button button--color"
          target="_blank"
          data-product-link
        >Купить</a>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, computed, onMounted } from 'vue';
const props = defineProps({
  isNew: {
    type: Boolean,
    default: false
  },
  rating: {
    type: Number,
    default: 0
  },
  variations: {
    type: Array,
  },
  title: {
    type: String,
    default: ''
  },
  subtitle: {
    type: String,
    default: ''
  },
  loggedIn: {
    type: Boolean,
    default: false
  },
});

const currentVariation = ref(0);

const currentimages = computed(() => props.variations[currentVariation.value].images);

const setCurrentVariation = (key) => {
  currentVariation.value = key;
}

const popupBuyShow = ref(false);

const popupBuy = ref(null);


const showPopupBuy = () => {
  popupBuyShow.value = true;
  const popupHeight = popupBuy.value.offsetHeight;
  document.getElementById('arrowTop').style.bottom = popupHeight + 50 + 'px';
}

const hidePopupBuy = () => {
  popupBuyShow.value = false;
  document.getElementById('arrowTop').style.bottom = '50px';
}

const closePopupBuy = () => {
  hidePopupBuy();
  window.removeEventListener("scroll", initPopupBuy);
}

const initPopupBuy = () => {
  const scroll = window.pageYOffset;
  const productPosition = document.querySelector('.detail-product__controls').getBoundingClientRect().bottom + scroll;
  const footerPosition = document.querySelector('.footer').getBoundingClientRect().top + scroll - window.innerHeight;

  if (scroll > productPosition && scroll < footerPosition) {
    showPopupBuy();
  } else {
    hidePopupBuy();
  }
}

onMounted(() => {
  if (!popupBuy.value) return false;
  initPopupBuy();
  window.addEventListener('scroll', initPopupBuy);

});

</script>
